jQuery(document).ready(function ($) {
	var DEFAULT_STRINGS = {
		invalid: 'Please enter a number from 0 to 99.',
		notAllowed: '{{ number }} is not allowed per NBA regulations.',
	};

	function getStrings($fields) {
		return {
			invalid: $fields.attr('data-msg-invalid') || DEFAULT_STRINGS.invalid,
			notAllowed: $fields.attr('data-msg-not-allowed') || DEFAULT_STRINGS.notAllowed,
		};
	}

	function getBlockedNumbers($fields) {
		var raw = ($fields.attr('data-blocked-numbers') || '').toString();

		return raw
			.split(',')
			.map(function (val) {
				return val.trim();
			})
			.filter(function (val) {
				return val !== '';
			});
	}

	function isCustomJerseyNumberValid($input) {
		if (!$input || !$input.length) {
			return false;
		}

		var raw = ($input.val() || '').toString().trim();

		if (raw === '') {
			return false;
		}

		if (!/^\d{1,2}$/.test(raw)) {
			return false;
		}

		var num = parseInt(raw, 10);

		if (isNaN(num) || num < 0 || num > 99) {
			return false;
		}

		var $fields = $input.closest('[data-custom-jersey-fields]');
		var blocked = getBlockedNumbers($fields);

		if (blocked.indexOf(String(num)) !== -1 || blocked.indexOf(raw) !== -1) {
			return false;
		}

		return true;
	}

	function updateNumberError($input) {
		var $fields = $input.closest('[data-custom-jersey-fields]');
		var $error = $fields.find('[data-custom-jersey-number-error]');
		var strings = getStrings($fields);
		var raw = ($input.val() || '').toString().trim();

		if (raw === '') {
			$error.prop('hidden', true).text('');
			$input.removeClass('is-invalid');
			return;
		}

		var num = parseInt(raw, 10);
		var blocked = getBlockedNumbers($fields);

		if (isNaN(num) || num < 0 || num > 99) {
			$error.prop('hidden', false).text(strings.invalid);
			$input.addClass('is-invalid');
			return;
		}

		if (blocked.indexOf(String(num)) !== -1 || blocked.indexOf(raw) !== -1) {
			$error
				.prop('hidden', false)
				.text(strings.notAllowed.replace('{{ number }}', num));
			$input.addClass('is-invalid');
			return;
		}

		$error.prop('hidden', true).text('');
		$input.removeClass('is-invalid');
	}

	function syncCustomJerseyPanels($wrap) {
		if (!$wrap || !$wrap.length) {
			return;
		}

		var $fields = $wrap.find('[data-custom-jersey-fields]');

		if (!$fields.length) {
			return;
		}

		var type = $fields.find('.js-custom-jersey-type:checked').data('custom-jersey-type');

		$fields.find('[data-custom-jersey-panel]').each(function () {
			var $panel = $(this);
			var panelType = $panel.data('custom-jersey-panel');
			var isActive = panelType === type;

			$panel.prop('hidden', !isActive);
			$panel.find('input, select, textarea').each(function () {
				var $input = $(this);

				if (isActive) {
					$input.prop('disabled', false);

					if ($input.is('[required]') || $input.hasClass('js-custom-jersey-required-when-active')) {
						$input.prop('required', true);
					}
				} else {
					$input.prop('required', false).prop('disabled', true);
				}
			});
		});

		if (typeof window.updateQuickViewCustomizationState === 'function') {
			window.updateQuickViewCustomizationState();
		}
	}

	$('body').on('change', '.js-custom-jersey-type', function () {
		syncCustomJerseyPanels($(this).closest('.quick-view__wrap'));
	});

	$('body').on('input change keyup', '.js-custom-jersey-number', function () {
		updateNumberError($(this));

		if (typeof window.updateQuickViewCustomizationState === 'function') {
			window.updateQuickViewCustomizationState();
		}
	});

	$('body').on(
		'change input keyup',
		'[data-custom-jersey-fields] input, [data-custom-jersey-fields] select',
		function () {
			if (typeof window.updateQuickViewCustomizationState === 'function') {
				window.updateQuickViewCustomizationState();
			}
		}
	);

	window.isCustomJerseyNumberValid = isCustomJerseyNumberValid;
	window.syncCustomJerseyPanels = syncCustomJerseyPanels;
});
